export const PATIENT_SELECTION_VIEW = 'PATIENT_SELECTION_VIEW';
export const NEW_USER = 'NEW_USER';
export const FIRST_EXISTING_USER = 'EXISTING_USER_0';
export const makeExistingUser = (index: number) => {
  return 'EXISTING_USER_' + index;
};
